import React, { useState } from "react"
import { Row, Col } from "react-bootstrap"
import CustomSingleSelect from "components/Shared/CustomSingleSelect"
import { useTranslation } from "react-i18next"

const AcWaEvaluationSection = ({ section, onAnswerChange }) => {
  const [answers, setAnswers] = useState({})

  const { t } = useTranslation()

  const generateOptions = max =>
    Array.from({ length: max + 1 }).map((_, i) => ({
      value: i,
      label: i.toString(),
    }))

  const handleSelectChange = (subQuestionId, selectedOption) => {
    const mark = selectedOption?.value
    const updatedAnswers = {
      ...answers,
      [subQuestionId]: mark,
    }

    const total = Object.values(updatedAnswers).reduce(
      (sum, val) => sum + val,
      0
    )
    setAnswers(updatedAnswers)

    const formattedAnswers = {
      main_question_id: section.main_question.id,
      total_mark: total,
      questions: {},
    }

    Object.keys(updatedAnswers).forEach(subId => {
      formattedAnswers.questions[subId] = updatedAnswers[subId]
    })

    onAnswerChange(section.id, formattedAnswers)
  }

  return (
    <div className="border rounded p-3 my-3">
      <h5 className="mb-3">{section.main_question.question}</h5>

      {section.sub_questions.map(sub => (
        <Row key={sub.id} className="align-items-center mb-3">
          <Col md={8}>
            <span>
              {sub.question_number}. {sub.question}
            </span>
          </Col>
          <Col md={4}>
            <CustomSingleSelect
              options={generateOptions(sub.max_mark)}
              onChange={option => handleSelectChange(sub.id, option)}
              value={
                answers[sub.id] !== undefined
                  ? {
                      value: answers[sub.id],
                      label: answers[sub.id].toString(),
                    }
                  : null
              }
              placeholder={t("Select Marks")}
            />
          </Col>
        </Row>
      ))}
    </div>
  )
}

export default AcWaEvaluationSection
